import RequestCorrectionPopup from '../../../views/time-tracker/correction/RequestCorrectionPopup.vue';
import {Popup} from '../../popup';

export const STATE_REQUESTED = 0;
export const STATE_REJECTED  = 1;
export const STATE_ACCEPTED  = 2;
export const STATE_WITHDRAWN = 3;

export const LOG_REJECTED  = 0;
export const LOG_EXECUTED  = 1;
export const LOG_REQUESTED = 2;
export const LOG_SUPERIOR  = 3;
export const LOG_AUTOMATIC = 4;

export const LOG_NOT_A_BREAK   = 0;
export const LOG_BREAK_ADDED   = 1;
export const LOG_BREAK_REMOVED = 2;

export function requestCorrection(employee: number, date?: string, events: { [key: string]: Function } = {})
{
    const popup = new Popup({
        title: `Zeitkorrektur beantragen`,
        titleIcon: 'edit',
        size: 'medium',
        component: RequestCorrectionPopup,
        componentProps: date ? {
            date,
            employee,
        } : {employee},
        events,
    });

    popup.open();

    return popup;
}